// extracted by mini-css-extract-plugin
export var avatar = "_pn-3";
export var avatarContainer = "_pn-2";
export var avatarSpacer = "_pn-5";
export var avatarSpacerContainer = "_pn-4";
export var avatarStackContainer = "_pn-1";
export var bubble = "_pn-0";
export var remainderBubble = "_pn-6";